import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../mock/mock";

const Logo = ({ compact = false, variant = "default" }) => {
  return (
    <Link to="/" className="flex items-center gap-2.5 group" aria-label="DoctorLab & Diagnostics – Home">
      <div className="relative shrink-0">
        <img
          src={LOGO_URL}
          alt="DoctorLab & Diagnostics logo"
          width={44}
          height={44}
          loading="eager"
          decoding="async"
          className="h-11 w-11 rounded-full object-cover ring-2 ring-slate-100 group-hover:ring-blue-200 transition"
        />
      </div>
      {!compact && (
        <div className="leading-tight">
          <div className={`font-bold text-[15px] tracking-tight ${variant === "light" ? "text-white" : "text-slate-900"}`}>
            Doctor<span className={variant === "light" ? "text-amber-300" : "text-dl-blue"}>Lab</span>
          </div>
          <div className={`text-[9px] sm:text-[10px] uppercase tracking-widest font-semibold ${variant === "light" ? "text-amber-200/80" : "text-slate-500"}`}>& Diagnostics</div>
        </div>
      )}
    </Link>
  );
};

export default Logo;
